var AuthControl = function () {


  // Hızlı giriş
  var QuickLogin = function () {

    var form = document.querySelector('[data-quick-login-form]');

    // console.log(form);
    if (!form) {
      return;
    }

    // giriş yap butonu
    $(form).on('click', '[data-quick-login-submit]', function (event) {
      event.preventDefault();

      $(form).find('.invalid-feedback').empty();
      $(form).find('*').removeClass('is-invalid');
      $(form).find('.valid-feedback').empty();
      $(form).find('*').removeClass('is-valid');

      $.ajax({
        url: baseUrl + '/login',
        type: "POST",
        dataType: "json",
        data: $(form).serialize(),
        error: function error(xhr) {
          $(form).find('.invalid-feedback').empty();
          $(form).find('*').removeClass('is-invalid');
          $.each(xhr.responseJSON.errors, function (name, message) {

            let element = form.querySelector('[name="' + name + '"]')

            element.classList.add('is-invalid')

            let valid = element.closest('div')
              .querySelector('.invalid-feedback');
            valid.style.display = 'block'
            valid.innerHTML = message;

          });
        },
        success: function success(xhr) {

          if (xhr.two_factor) {
            window.location.href = '/two-factor-challenge';
          } else {
            location.reload();
          }

        }
      });

    });


  }

  return {
    init: function () {
      QuickLogin();
    }
  }
}();

$(function () {
  AuthControl.init();
});

// Example starter JavaScript for disabling form submissions if there are invalid fields
(() => {
  'use strict'

  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  const forms = document.querySelectorAll('.needs-validation')

  // Loop over them and prevent submission
  Array.from(forms).forEach(form => {
    form.addEventListener('submit', event => {
      if (!form.checkValidity()) {
        event.preventDefault()
        event.stopPropagation()
      }

      form.classList.add('was-validated')
    }, false)
  })
})()